import { Question } from './question.model';
import { Survey } from './survey.model';

export class QuestionGroup {
  description?: string;
  id?: number;
  name?: string;
  position?: number;
  questions?: Question[] | string[];
  survey?: Survey | string;
  topic?: string;

  constructor(values= {}) {
    Object.assign(this, values);
  }
}
